import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import { getCivilIcon } from '../../components/CivilIcons';

const toCardItems = (items: any[]) =>
  (items || []).map((item: any) => ({
    title: item.title || '',
    content: item.content || '',
    icon: getCivilIcon(item.icon),
  }));

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[2],
    [settings?.paragraphs]
  );

  const handleReportComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-core-section2-1');
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="core-section">
      <div className="content-block content-block-cards">
        <HighlightedCardsGrid
          mainTitle={paragraphSettings?.section1Title}
          description={paragraphSettings?.section1Desc}
          items={toCardItems(paragraphSettings?.section1Items)}
        />
      </div>
      <div className="content-block content-block-cards">
        <HighlightedCardsGrid
          mainTitle={paragraphSettings?.section2Title}
          description={paragraphSettings?.section2Desc}
          items={toCardItems(paragraphSettings?.section2Items)}
        />
      </div>
      <div className="content-block content-block-steps">
        <NumberedStepsCarousel
          type="simple"
          id="civil-core-section2-1"
          mainTitle={paragraphSettings?.section3Title}
          description={paragraphSettings?.section3Desc}
          items={(paragraphSettings?.section3Items || []).map((item: any) => ({
            text: item.text || '',
          }))}
          defaultActive={0}
          onComplete={handleReportComplete}
        />
      </div>
    </div>
  );
};

export default Section2;
